import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-two-factor-auth-input',
    templateUrl: './two-factor-auth-input.component.html',
    standalone: false
})
export class TwoFactorAuthInputComponent implements OnInit {
  @Input() showTitle: boolean = true;
  @Input() h2: string;
  @Input() description: string = 'twoFactor.enterSixDigit';
  @Input() wrapperClass: string = 'tw-items-center';
  // GRC-2814: mirrors the parent LoginComponent's isSubmitting flag so the Verify button can't
  // be re-clicked while the previous OTP submission is still in flight. This is UX/defense in
  // depth only, NOT what closes the double-submit race: `disabled` is an @Input and only updates
  // on Angular's next change-detection pass, so two clicks dispatched in the same tick (no yield
  // in between) can both reach onSubmit() before this value flips. The actual guarantee against
  // a duplicate HTTP call is the synchronous `isSubmitting` check in LoginComponent.submit(),
  // which both this component's (otpChange) and the step-1 form ultimately funnel through.
  @Input() disabled: boolean = false;
  @Output() otpChange = new EventEmitter();

  form: UntypedFormGroup;
  showFormError: boolean = false;

  constructor(private readonly formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  onSubmit() {
    if (this.disabled) {
      return;
    }

    if (this.form.invalid) {
      this.showFormError = true;
      return;
    }

    this.otpChange.emit(this.form.value.otp);
  }
}
